import type { AxiosError } from 'axios';

import type { CommonResponse } from '../types';
import type { Mismatch } from '../types/common-response';

export const getMismatches = (error: AxiosError<CommonResponse>) =>
  error?.response?.data?.flkReport?.mismatches;

export const getMismatchesFromUnknown = (error: unknown) =>
  // @ts-expect-error ignore getting mismatches from unknown
  error?.response?.data?.flkReport?.mismatches as Mismatch[] | undefined;
